module.exports = __webpack_public_path__ + "om.a8ffbc41f0ebc137bf2c.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/om.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/om.svg
// module chunks = styles